// Toggle search
$('#header [data-toggle-search]').click(function (e) {
	e.preventDefault();
	$('#header').removeClass('menu-open').removeClass('menu-open-deep');
	$('#header').toggleClass('search-open');

	if ($('#header').is('.search-open')) {
		$('#header input[name=s]').focus();
	}
});

// Toggle menu
$('#header [data-toggle-menu]').click(function (e) {
	e.preventDefault();

	$('#header').removeClass('search-open');

	if ($('#header').is('.menu-open-deep')) {
		$('#header').removeClass('menu-open-deep');
	}
	else {
		$('#header').toggleClass('menu-open');
	}
});

// Open deep
/* $('#header .main-menu > li.dropdown > a').click(function (e) {
	e.preventDefault();

	$('#header .main-menu > li').removeClass('open');
	$(this).parent().addClass('open');
	$('#header').addClass('menu-open-deep');
}); */

// Open regularly
$('#header .main-menu > li.dropdown > a').click(function (e) {
	e.preventDefault();

	var wasOpen = $(this).parent().hasClass('open');

	$('#header .main-menu > li').removeClass('open');

	if (!wasOpen) {
		$(this).parent().addClass('open');
	}
});